import { I18nProvider } from "react-aria-components";
import { ErrorBoundary } from "react-error-boundary";
import { RouterProvider } from "react-router/dom";

import { errorHandler } from "../helpers/errorHandler";
import { AppProvider } from "./components/AppProvider";
import { DataProvider } from "./components/DataProvider";
import { ErrorFallback } from "./components/ErrorFallback";
import { router } from "./router";

export const App = () => (
	<ErrorBoundary onError={errorHandler} FallbackComponent={ErrorFallback}>
		<AppProvider>
			<DataProvider>
				<I18nProvider locale="en-US">
					<RouterProvider router={router} />
				</I18nProvider>
			</DataProvider>
		</AppProvider>
	</ErrorBoundary>
);
